module.exports = __webpack_public_path__ + "media/images/logo-old-80c43e5db54ffd888c9b4884f52516f1.png";